import { Polygon } from './../polygon';
import { ProjectType } from './../project';
import { Point } from './../point';
import { KnaufColor } from './../knauf-color';
import { Layer } from './../layer';
import { KnaufPaletteSetService } from './../knauf-palette-set.service';
import { Component, OnInit, ViewChild, ElementRef, HostListener } from '@angular/core';
import { KnaufPaletteSets } from '../knauf-palette-sets';
import { KnaufPalettes } from '../knauf-palettes.enum';
import { ProjectService } from '../project.service';
import { CompareProjectsService } from '../compare-projects.service';
import { Project } from '../project';
import { EditorTool } from '../editor-tool.enum';
import { LayerHistoryService } from '../layer-history.service';
import { ModalService } from '../modal.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Router } from '@angular/router';
import { faPlus, faEdit, faDownload, faUndo, faRedo, faEraser, faSearchPlus, faSearchMinus, faEye, faPlusCircle, faMinusCircle } from '@fortawesome/free-solid-svg-icons';


@Component({
  selector: 'app-editor',
  templateUrl: './editor.component.html',
  styleUrls: ['./editor.component.sass']
})
export class EditorComponent implements OnInit {


  @ViewChild('projectcanvas') projectcanvas: ElementRef;
  @ViewChild('imgclip') imgclip: ElementRef;

  next: string = "/finished-project"
  styles = {
    selected: null,
    items: [
      { name: "Miejski szyk", class: "ms", palette: null, knaufPalette: KnaufPalettes.MiejskiSzyk, description: 'Paleta kolorów oparta na odcieniach szarości, inspirowana stylem skandynawskim, minimalizmem i najnowszymi trendami w projektowaniu.Doskonale sprawdza się w połączeniu z prostymi bryłami i modernistyczną architekturą, spotykaną w przypadku nowo budowanych domów, częściej w przestrzeni miejskiej.' },
      { name: "Klasyczna elegancja", class: "ke", palette: null, knaufPalette: KnaufPalettes.KlasycznaElegancja, description: 'Paleta ciepłych, stonowanych barw dla osób szukających inspiracji w tradycyjnych projektach architektonicznych. Szlachetne beże i brązy nadadzą nawet nowoczesnym domom klasyczny, elegancki wygląd.' },
      { name: "Światowe inspiracje", class: "si", palette: null, knaufPalette: KnaufPalettes.SwiatoweInspiracje, description: 'Paleta najbardziej różnorodnych kolorów, przywołujących ciepłe i intensywne barwy architektury śródziemnomorskiej. Punkt wyjścia do tworzenia odważnych i bogatych zestawień kolorystycznych na elewacjach budynków, zainspirowanych nowoczesną architekturą światową.' },
      { name: "W zgodzie z naturą", class: "zn", palette: null, knaufPalette: KnaufPalettes.WZgodzieZNatura, description: 'Paleta łagodnych odcieni zieleni i brązu dla wszystkich miłośników przyrody i spokojnego trybu życia. Barwy, które bardzo dobrze wpisują się w naturalne otoczenie, doskonały wybór dla domu w pobliżu lasu, jeziora czy parku. Sprawdzą się zarówno w budownictwie tradycyjnym, jak i nowoczesnym.' },
      { name: "Wszystkie kolory Knauf", class: "all", palette: null, knaufPalette: KnaufPalettes.WszystkieKolory, description: 'Wszystkie kolory Knauf' }
    ]
  }
  paletteDesc: boolean = false;
  palettes: KnaufPaletteSets;
  KnaufPalettes = KnaufPalettes;
  knaufPalette: number;
  project: Project;
  layers: Layer[] = [];
  points: Point[] = [];
  editorTool: EditorTool = EditorTool.invalid;
  EditorTool = EditorTool
  scale: number = 1;
  zoom: number = 1;
  move: boolean = false;
  movePoint: boolean = false;
  canvasStartPoint: Point = { x: 0, y: 0 };
  selectedPoint: Point = null;
  mobileColorsActive: number = 0;
  mobileActionActive: number = 0;
  showInfo: string = '';
  touchStartPoint: Point = { x: 0, y: 0 };
  layername: string = null;
  editLayer: Layer = null;
  opacityChanged: boolean = false;
  layerToDelete: Layer = null;
  faPlus = faPlus;
  faEdit = faEdit;
  faDownload = faDownload;
  faUndo = faUndo;
  faRedo = faRedo;
  faEraser = faEraser;
  faSearchPlus = faSearchPlus;
  faSearchMinus = faSearchMinus;
  faEye = faEye;
  faPlusCircle = faPlusCircle;
  faMinusCircle = faMinusCircle;



  constructor(
    private palettesService: KnaufPaletteSetService,
    private projectService: ProjectService,
    private compareProjectsService: CompareProjectsService,
    private layerHistory: LayerHistoryService,
    private modalService: ModalService,
    private deviceService: DeviceDetectorService,
    private router: Router) { }

  ngOnInit() {
    this.palettes = this.palettesService.getKnaufPaletteSets();
    this.styles.items[0].palette = this.palettes[KnaufPalettes.MiejskiSzyk];
    this.styles.items[1].palette = this.palettes[KnaufPalettes.KlasycznaElegancja];
    this.styles.items[2].palette = this.palettes[KnaufPalettes.SwiatoweInspiracje];
    this.styles.items[3].palette = this.palettes[KnaufPalettes.WZgodzieZNatura];
    this.styles.items[4].palette = this.palettes[KnaufPalettes.WszystkieKolory];
    this.project = this.projectService.getProject();
    this.knaufPalette = this.project.knaufPalette;
    this.styles.selected = this.styles.items[this.knaufPalette];
    this.layers = this.project.layers;
    this.updateProject();
    var bg: HTMLImageElement = <HTMLImageElement>document.getElementById('project-image');
    var that = this;
    bg.onload = function () { that.onResize(null); }
    this.storeCurrentShanpshot();

    this.drawlayers();
  }

  isMobile() {
    return this.deviceService.isMobile();
  }

  @HostListener('document:click', ['$event'])
  documentClick(event: MouseEvent) {
    var target: HTMLElement = <HTMLElement>event.target;
    if (target.classList.length  && target.classList.contains('tool')) {
      return;
    }
    if (this.editorTool != EditorTool.invalid && !target.classList.contains('remains')) {
      this.editorTool = EditorTool.invalid;
      this.points = [];
      this.drawlayers();
    }
  }

  onToolTip(tip: string) {
    this.showInfo = tip;
  }
  onStyleClick(item) {
    this.styles.selected = item;
    if (item.knaufPalette == KnaufPalettes.WszystkieKolory) {
      this.mobileColorsActive = 0;
    }
    this.updateProject();
  }

  updateProject() {
    this.projectService.setKnaufPalette(this.styles.selected.knaufPalette);
  }

  storeCurrentShanpshot() {
    this.layerHistory.addSnapshot(JSON.parse(JSON.stringify(this.layers)));
  }

  addProjectToCompare() {
    if (this.compareProjectsService.getProjects().length == 2) {
      this.modalService.open('warning-dlg');
    } else {
      this.projectService.setProjectImageFile(this.getProjectImageFromCanvas());
      this.projectService.setLayers(this.layers);
      this.compareProjectsService.addProject(this.project);
      this.modalService.open('confirmation-dlg');
    }
  }
  goToMyProjects() {
    this.closeModal('warning-dlg');
    this.router.navigate(['/my-projects/fromedit']);
  }
  selectLayer(layer: Layer) {
    this.checkIfOpacityChanged();
    layer.selected = !layer.selected;
    this.storeCurrentShanpshot();
    this.drawlayers();
  }

  clearLayer() {
    this.checkIfOpacityChanged();
    this.layers = this.layers.filter(obj => obj !== this.layerToDelete);
    this.storeCurrentShanpshot();
    this.drawlayers();
    this.modalService.close('delete-layer-dlg');
  }

  selectColor(color: KnaufColor) {
    this.checkIfOpacityChanged();
    for (let layer of this.layers) {
      if (layer.selected) {
        layer.color = color;
      }
    }
    this.storeCurrentShanpshot();
    this.drawlayers();
  }

  toolSelect() {
    if (this.editorTool == EditorTool.Select) {
      this.editorTool = EditorTool.invalid;
    } else {
      this.editorTool = EditorTool.Select;
    }
    this.projectcanvas.nativeElement.style.cursor = 'default';

    this.unselectAllLayers();
    this.drawlayers();
  }

  toolMove() {
    if (this.editorTool == EditorTool.Move) {
      this.editorTool = EditorTool.invalid;
      this.projectcanvas.nativeElement.style.cursor = 'default';
    } else {
      this.editorTool = EditorTool.Move;
      this.projectcanvas.nativeElement.style.cursor = 'grab';
    }
    this.drawlayers();
  }

  toolCut() {
    if (this.editorTool == EditorTool.Cut) {
      this.editorTool = EditorTool.invalid;
    } else {
      this.editorTool = EditorTool.Cut;
    }
    this.projectcanvas.nativeElement.style.cursor = 'default';

    this.drawlayers();
  }

  zoomIn() {
    this.zoom += 0.5;
    this.onResize(null);

    this.canvasStartPoint.x *= 1.5;
    this.canvasStartPoint.y *= 1.5;
    this.projectcanvas.nativeElement.style.left = String(this.canvasStartPoint.x) + 'px';
    this.projectcanvas.nativeElement.style.top = String(this.canvasStartPoint.y) + 'px';
    this.editorTool = EditorTool.Move;
  }

  zoomOut() {
    if (this.zoom > 1) {
      this.zoom -= 0.5;
      var bg: HTMLImageElement = <HTMLImageElement>document.getElementById('project-image');

      var maxLeft = bg.width - bg.width * this.zoom;
      var maxTop = bg.height - bg.height * this.zoom;

      if (this.canvasStartPoint.x > 0) {
        this.canvasStartPoint.x = 0;
      }
      if (this.canvasStartPoint.x < maxLeft) {
        this.canvasStartPoint.x = maxLeft;
      }
      if (this.canvasStartPoint.y > 0) {
        this.canvasStartPoint.y = 0
      }
      if (this.canvasStartPoint.y < maxTop) {
        this.canvasStartPoint.y = maxTop;
      }
      this.projectcanvas.nativeElement.style.left = String(this.canvasStartPoint.x) + 'px';
      this.projectcanvas.nativeElement.style.top = String(this.canvasStartPoint.y) + 'px';
    }
    this.onResize(null);
    this.editorTool = EditorTool.Move;
  }

  goBack() {
    if (this.editorTool == EditorTool.Select || this.editorTool == EditorTool.Cut) {
      this.points.pop();
      this.drawlayers();
      return;
    }
    if (this.project.projectType == ProjectType.predefined && this.layerHistory.getHistoryLength() == 1) {
      return
    }
    this.layerHistory.goBack();
    this.layers = this.layerHistory.getCurrentSnapshot();
    this.drawlayers();
  }

  goForward() {
    this.layerHistory.goForward();
    this.layers = this.layerHistory.getCurrentSnapshot();
    this.drawlayers();
  }

  resetEditor() {
    if (this.project.projectType == ProjectType.predefined) {
      this.layerHistory.clear(1);
    } else {
      this.layerHistory.clear();
    }
    this.layers = this.layerHistory.getCurrentSnapshot();
    this.drawlayers();
    this.modalService.close('delete-dlg');
  }

  selectedLayers() {
    let selected = 0;
    this.layers.forEach(function (layer) {
      if (layer.selected) {
        selected++;
      }
    })
    return selected
  }

  unselectAllLayers() {
    this.checkIfOpacityChanged();
    this.layers.forEach(function (layer) {
      layer.selected = false;
    });
    this.storeCurrentShanpshot();
    this.drawlayers();
  }

  selectedLayer(): Layer {
    for (let layer of this.layers) {
      if (layer.selected) {
        return layer;
      }
    }
    return null;
  }

  onCanvasClick(event: MouseEvent) {
    if (this.editorTool == EditorTool.DelPoint) {
        if (this.selectedPoint) {
          this.checkIfOpacityChanged();
          let layer = this.selectedLayer();
          if (layer) {
            let index: number = layer.points.findIndex((element) => {return this.selectedPoint == element; });
            if (index >=0) {
              layer.points.splice(index, 1);
              if (layer.points.length == 0) {
                this.layers = this.layers.filter(obj => obj !== layer);
              }
            } else if (layer.cuts.length) {
              for (let cut of layer.cuts) {
                let index: number = cut.findIndex((element) => {return this.selectedPoint == element; });
                if (index > -1) {
                  cut.splice(index, 1);
                }
                if (cut.length == 0) {
                  let cutIndex = layer.cuts.findIndex((element) => { return cut === element; });
                  if (cutIndex > -1) {
                    layer.cuts.splice(cutIndex, 1);
                  }
                }
              }
            }
            this.selectedPoint = null;
            this.storeCurrentShanpshot();
          }
        }
        this.drawlayers();
      return;
    }
    var point = { x: event.offsetX * this.scale / this.zoom, y: event.offsetY * this.scale / this.zoom };


    if (this.editorTool == EditorTool.AddPoint) {
      let point = this.pointCloseToLine(event, true);
      if (point) {
        this.drawlayers();
      }
      return;
    }
    if (this.editorTool != EditorTool.Select && this.editorTool != EditorTool.Cut) {
      let p : Polygon = new Polygon();
      for (let layer of this.layers) {
        if (p.isInside(layer.points, point)) {
          layer.selected = true;
          this.drawlayers();
        }
      }
      return;
    }

    var pathCompelte: boolean = false;
    if (this.points.length > 2) {
      if (Math.abs(this.points[0].x - point.x) < 10 && Math.abs(this.points[0].y - point.y) < 10) {
        point.x = this.points[0].x;
        point.y = this.points[0].y;
        pathCompelte = true;
      }
    }
    if (!pathCompelte) {
      this.points.push(point);
    }
    if (pathCompelte) {
      this.checkIfOpacityChanged();
      if (this.editorTool == EditorTool.Select) {
        let layer = new Layer;
        this.unselectAllLayers();
        layer.selected = true;
        layer.points = this.points;
        layer.opacity = 80;
        this.layers.push(layer);
        this.editorTool = EditorTool.invalid;
      } else if (this.editorTool == EditorTool.Cut) {
        let layer = this.selectedLayer();
        if (layer) {
          layer.cuts.push(this.points);
        }
      }
      this.storeCurrentShanpshot();
      this.points = [];
    }
    this.drawlayers();
  }

  onResize(event) {
    var bg: HTMLImageElement = <HTMLImageElement>document.getElementById('project-image');
    var canvas: HTMLCanvasElement = <HTMLCanvasElement>document.getElementById("project-viewport");
    var imgclip: HTMLDivElement = <HTMLDivElement>document.getElementsByClassName('img-clip')[0];

    imgclip.style.height = String(bg.height) + 'px';
    canvas.style.height = String(bg.height * this.zoom) + 'px';
    canvas.style.width = String(bg.width * this.zoom) + 'px';
    canvas.width = bg.naturalWidth;
    canvas.height = bg.naturalHeight;

    this.scale = bg.naturalWidth / bg.width;
    this.drawlayers();
  }

  drawlayers() {
    var canvas: HTMLCanvasElement = <HTMLCanvasElement>document.getElementById("project-viewport");
    var canvasTmp: HTMLCanvasElement = <HTMLCanvasElement>document.createElement('canvas');
    canvasTmp.width = canvas.width;
    canvasTmp.height = canvas.height;

    var ctx: CanvasRenderingContext2D = canvasTmp.getContext('2d');
    var bg: HTMLImageElement = <HTMLImageElement>document.getElementById('project-image');
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    ctx.strokeStyle = '#00FF00FF';
    ctx.lineWidth = 4;
    ctx.lineJoin = "round";

    var ctxPrj: CanvasRenderingContext2D = canvas.getContext('2d');
    ctxPrj.drawImage(bg, 0, 0, canvas.width, canvas.height);

    for (let layer of this.layers) {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      this.drawLayer(layer, ctx);
      ctxPrj.drawImage(canvasTmp, 0, 0);
    }

    for (let layer of this.layers) {
      if (layer.selected) {
        this.drawLayerLines(layer, ctxPrj);
      }
    }

    if (this.points.length) {
    this.drawLines(this.points, ctxPrj, false);
    }

    if (this.selectedPoint) {
      ctxPrj.beginPath();
      ctxPrj.fillStyle = '#FFFF00FF';
      ctxPrj.lineWidth = 4;
      ctxPrj.arc(this.selectedPoint.x, this.selectedPoint.y, 5, 0, 2 * Math.PI, false);
      ctxPrj.fill();
    }
  }

  drawLines(points: Point[], ctx: CanvasRenderingContext2D, closePath: boolean = true) {
    ctx.strokeStyle = '#00FF00FF';
    ctx.lineWidth = 4;
    ctx.lineJoin = "round";
    ctx.beginPath();
    ctx.moveTo(points[0].x, points[0].y);
    for (let point of points) {
      ctx.arc(point.x, point.y, 3, 0, 2 * Math.PI);
      ctx.lineTo(point.x, point.y);
    }
    if (closePath) {
      ctx.closePath();
    }
    ctx.stroke();
  }

  drawFilledPoints(points: Point[], ctx: CanvasRenderingContext2D, color: string) {
    ctx.beginPath();
    ctx.moveTo(points[0].x, points[0].y);
    for (let point of points) {
      ctx.lineTo(point.x, point.y);
    }
    ctx.lineTo(points[0].x, points[0].y);
    ctx.closePath();
    if (color && color != '') {
      ctx.fillStyle = color;
      ctx.fill();
    }
  }

  private getAlpha(opacity: number): string {
    let op = Number(Math.round(opacity * 2.55)).toString(16);
    if (op.length == 1) {
      op = '0' + op;
    }
    return op;
  }

  drawLayer(layer: Layer, ctx: CanvasRenderingContext2D) {
    let color = layer.color ? layer.color.rgb + (layer.selected && this.editorTool == EditorTool.Cut ? 'A0' : this.getAlpha(layer.opacity)) : null;
    this.drawFilledPoints(layer.points, ctx, color);

    if (layer.cuts.length) {
      for (let cut of layer.cuts) {
        ctx.save();
        this.drawFilledPoints(cut, ctx, null);
        ctx.clip();
        ctx.clearRect(0, 0, 2000, 2000);
        ctx.restore();
      }
    }
  }

  drawLayerLines(layer: Layer, ctx: CanvasRenderingContext2D) {
    this.drawLines(layer.points, ctx);
    if (layer.cuts.length) {
      for (let cut of layer.cuts) {
        this.drawLines(cut, ctx);
      }
    }
  }

  closeModal(dlg: string) {
    this.modalService.close(dlg);
  }

  preview() {
    var image: HTMLImageElement = <HTMLImageElement>document.getElementsByClassName('preview-image')[0];
    image.src = this.getProjectImageFromCanvas();
    this.modalService.open('preview-dialog');
  }

  getProjectImageFromCanvas() {
    this.checkIfOpacityChanged();
    this.unselectAllLayers();
    var newcanvas: HTMLCanvasElement = <HTMLCanvasElement>document.createElement('canvas');
    var canvas: HTMLCanvasElement = <HTMLCanvasElement>document.getElementById("project-viewport");
    newcanvas.height = canvas.height;
    newcanvas.width = canvas.width;

    var ctx: CanvasRenderingContext2D = newcanvas.getContext('2d');
    var bg: HTMLImageElement = <HTMLImageElement>document.getElementById('project-image');
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(bg, 0, 0, canvas.width, canvas.height + bg.height - canvas.height);
    ctx.drawImage(canvas, 0, 0);

    var img = newcanvas.toDataURL('image/jpeg');
    this.goBack();
    return img;
  }

  onNextClick(event: string) {
    this.projectService.setProjectImageFile(this.getProjectImageFromCanvas());
    this.projectService.setLayers(this.layers);
  }

  onMouseOver(event: any) {
  }

  onMouseDown(event: any) {
    if (this.editorTool == EditorTool.Move) {
      this.move = true;
    }
    if (this.selectedPoint) {
      this.movePoint = true;
    }
  }
  onTouchStart(event: any) {
    this.touchStartPoint = this.getEventPoint(event);
    this.onMouseMoveOverCanvas(event, 20);
    this.onMouseDown(event);
    if (this.movePoint || this.move)
      event.preventDefault();
  }
  onMouseUp(event: any) {
    this.move = false;
    this.movePoint = false;
  }

  onMouseLeave(event: any) {
    this.move = false;
  }

  pointIsCloseToMouse(point: Point, mouse: Point, close: number) {
    let a = point.x - mouse.x;
    let b = point.y - mouse.y;

    return Math.sqrt(a * a + b * b) <= close;
  }

  onMouseMove(event: any) {
    if (event.movementX == 0 && event.movementY == 0) {
      return;
    }
    if (this.editorTool == EditorTool.Move && this.move) {
      var bg: HTMLImageElement = <HTMLImageElement>document.getElementById('project-image');
      var maxLeft = bg.width - bg.width * this.zoom;
      var maxTop = bg.height - bg.height * this.zoom;
      if (event.movementX) {
        this.canvasStartPoint.x += event.movementX;
        this.canvasStartPoint.y += event.movementY;
      } else if (event.touches) {
        let eventPoint: Point = this.getEventPoint(event);
        let movement: Point = { x: eventPoint.x - this.touchStartPoint.x, y: eventPoint.y - this.touchStartPoint.y };
        this.canvasStartPoint.x += movement.x;
        this.canvasStartPoint.y += movement.y;
      }
      this.canvasStartPoint.x = this.clamp(maxLeft, this.canvasStartPoint.x, 0);
      this.canvasStartPoint.y = this.clamp(maxTop, this.canvasStartPoint.y, 0);

      this.projectcanvas.nativeElement.style.left = String(this.canvasStartPoint.x) + 'px';
      this.projectcanvas.nativeElement.style.top = String(this.canvasStartPoint.y) + 'px';
    } else if (this.selectedPoint && this.movePoint) {

      let eventPoint: Point = this.getEventPoint(event);
      if (event.layerX && !event.touches) {
        this.selectedPoint.x += event.movementX * this.scale / this.zoom;
        this.selectedPoint.y += event.movementY * this.scale / this.zoom;
      } else if (event.touches) {
        this.selectedPoint.x += eventPoint.x * this.scale / this.zoom - this.selectedPoint.x;
        this.selectedPoint.y += eventPoint.y * this.scale / this.zoom - this.selectedPoint.y;
      }

      this.drawlayers();
    } else if (this.editorTool == EditorTool.invalid || this.editorTool == EditorTool.DelPoint) {
      this.onMouseMoveOverCanvas(event, 10);
    } else if (this.editorTool == EditorTool.AddPoint) {
      this.onMouseMoveOverCanvasWithAddPoint(event);
    }
  }
  pointCloseToLine(event, insert: boolean = false): Point {
    let layer  = this.selectedLayer();
    if (layer) {
      if ((!event.layerX && !event.targetTouches) || (!event.layerY && !event.targetTouches)) {
        return null;
      }
      let eventPoint: Point = {x: event.layerX ? event.layerX : event.targetTouches[0].clientX - event.target.getBoundingClientRect().x,
        y: event.layerY ? event.layerY : event.targetTouches[0].clientY - event.target.getBoundingClientRect().y};
      let mousePoint: Point = { x: eventPoint.x * this.scale / this.zoom, y: eventPoint.y * this.scale / this.zoom };
      for (let index = 0; index < layer.points.length-1; index++) {
        let p3 = this.distanceToLine(layer.points[index], layer.points[index+1], mousePoint, 5);
        if (p3) {
          if (insert) {
            layer.points.splice(index+1, 0, p3);
          }
          return p3;
        }
      }
      let p3 = this.distanceToLine(layer.points[0], layer.points[layer.points.length-1], mousePoint, 5);
        if (p3) {
          if (insert) {
            layer.points.push(p3);
          }
          return p3;
        }
      for (let cut of layer.cuts) {
        for (let index = 0; index < cut.length-1; index++) {
          let p3 = this.distanceToLine(cut[index], cut[index+1], mousePoint, 5);
          if (p3) {
            if (insert) {
              cut.splice(index+1, 0, p3);
            }
            return p3;
          }
        }
        let p3 = this.distanceToLine(cut[0], cut[cut.length-1], mousePoint, 5);
          if (p3) {
            if (insert) {
              cut.push(p3);
            }
            return p3;
          }
      }
      if (layer.points.length == 1) {
        if (insert) {
          layer.points.push(mousePoint);
        }
        return mousePoint;
      }
    }
    return null;
  }

  onMouseMoveOverCanvasWithAddPoint(event) {
    this.selectedPoint = this.pointCloseToLine(event);
    this.drawlayers();
  }

  getEventPoint(event): Point {
    return  {x: event.layerX ? event.layerX : event.targetTouches[0].clientX - event.target.getBoundingClientRect().x,
      y: event.layerY ? event.layerY : event.targetTouches[0].clientY - event.target.getBoundingClientRect().y};
  }

  onMouseMoveOverCanvas(event, closeRadius: number) {
    if (this.editorTool != EditorTool.invalid && this.editorTool != EditorTool.DelPoint) { return; }
    this.selectedPoint = null;
    let eventPoint: Point = {x: event.layerX ? event.layerX : event.targetTouches[0].clientX - event.target.getBoundingClientRect().x,
                             y: event.layerY ? event.layerY : event.targetTouches[0].clientY - event.target.getBoundingClientRect().y};
    let mousePoint: Point = { x: eventPoint.x * this.scale / this.zoom, y: eventPoint.y * this.scale / this.zoom };
    for (let layer of this.layers) {
      if (!layer.selected) {
        continue;
      }
      for (let point of layer.points) {
        if (this.pointIsCloseToMouse(point, mousePoint, closeRadius)) {
            this.selectedPoint = point;
        }
      }
      for (let points of layer.cuts) {
        for (let point of points) {
          if (this.pointIsCloseToMouse(point, mousePoint, closeRadius)) {
              this.selectedPoint = point;
          }
        }
      }
    }
    this.drawlayers();
  }

  clamp(min: number, mid: number, max: number) {
    return mid < min ? min : mid < max ? mid : max
  }

  onInfoButtonClick() {
    this.paletteDesc = !this.paletteDesc;
  }

  mobileSelectColorsActive(colors: number) {
    this.mobileColorsActive = colors;
  }

  onMobileActionActive(action: number) {
    this.mobileActionActive = action;
  }

  isAllPalettesSelected(): boolean {
    return this.styles.selected.knaufPalette == KnaufPalettes.WszystkieKolory;
  }

  toolDeletePoint() {
    if (this.editorTool == EditorTool.DelPoint) {
      this.editorTool = EditorTool.invalid;
    } else {
      this.editorTool = EditorTool.DelPoint;
    }
  }

  toolAddPoint() {
    if (this.editorTool == EditorTool.AddPoint) {
      this.editorTool = EditorTool.invalid;
    } else {
      this.editorTool = EditorTool.AddPoint;
    }
  }

  distanceToLine(p1: Point, p2: Point, p: Point, d: number): Point {
    var A = p2.x - p1.x,
      B = p2.y - p1.y,
      p3: Point;
    var u = (A * (p.x - p1.x) + B * (p.y - p1.y)) / (Math.pow(A, 2) + Math.pow(B, 2));
    if (u <= 0) {
      p3 = p1;
    }
    else if (u >= 1) {
      p3 = p2;
    }
    else {
      p3 = {
        x: p1.x + u * A,
        y: p1.y + u * B
      };
    }
    if ( Math.sqrt(Math.pow(p.x - p3.x, 2) + Math.pow(p.y - p3.y, 2)) < d) {
      return p3;
    } else {
      return null;
    }
  }
  onLayerNameChange(layer, index) {
    this.editLayer = this.layers[index];
    if (!this.editLayer.name) {
      this.layername = "Powierzchnia " + (index +1);
    } else {
      this.layername = this.editLayer.name;
    }
    this.modalService.open('editname-dlg');

  }

  changeName()  {
    this.editLayer.name = this.layername;
    this.modalService.close('editname-dlg');
  }

  onLayerOpacityChanged(event, layer: Layer) {
    layer.opacity = event.value;
    this.drawlayers();
    this.opacityChanged = true;
  }

  private checkIfOpacityChanged() {
    if (this.opacityChanged) {
      this.storeCurrentShanpshot();
      this.opacityChanged = false;
    }
  }

  public onResetEditor() {
    this.modalService.open('delete-dlg');
  }

  public onClearLayer(layer) {
    this.layerToDelete = layer;
    this.modalService.open('delete-layer-dlg');
  }
}

